import React from 'react'
import { ErrorMessage } from 'formik'

export default function ErrorMessageFormik(props) {
    return (
        <ErrorMessage  name={props.name} render={msg => <div className="text-danger">{msg}</div>}/>
    )
}
